const assert = require('assert');
const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class Ic2BookingServiceConnector {
  constructor(configuration) {
    assert(configuration, 'configuration is required');
    this.httpClient = axios.create(configuration);
  }

  async getAccountFields(params) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/ic2/accounts/fields`, { params });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  Ic2BookingServiceConnector,
};
